var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockUnlocked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 6.66634H13.3333C13.7015 6.66634 14 6.96481 14 7.33301V13.9997C14 14.3679 13.7015 14.6663 13.3333 14.6663H2.66667C2.29848 14.6663 2 14.3679 2 13.9997V7.33301C2 6.96481 2.29848 6.66634 2.66667 6.66634H3.33333V5.99967C3.33333 3.42235 5.42267 1.33301 8 1.33301C9.827 1.33301 11.4087 2.38287 12.1749 3.91222L10.9821 4.50863C10.4348 3.41625 9.305 2.66634 8 2.66634C6.15905 2.66634 4.66667 4.15873 4.66667 5.99967V6.66634ZM6.66667 9.99967V11.333H9.33333V9.99967H6.66667Z",
    fill: "#9CA2A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockUnlocked);
export default __webpack_public_path__ + "static/media/lock-unlocked.9123da228a970f4aa9bd7b1a591692b9.svg";
export { ForwardRef as ReactComponent };